<template>
  <div class="address-search" @focusout="closeAfterFocusChange">
    <label class="visually-hidden" for="header-address-search">Adressen durchsuchen</label>
    <div class="input-group input-group-sm">
      <CFormInput
        id="header-address-search"
        v-model="query"
        autocomplete="off"
        placeholder="Adressen suchen"
        @focus="open = true"
        @input="queueSearch"
        @keydown.down.prevent="moveSelection(1)"
        @keydown.up.prevent="moveSelection(-1)"
        @keydown.enter.prevent="openSelected"
        @keydown.esc.prevent="reset"
      />
      <span class="input-group-text" aria-hidden="true">
        <CSpinner v-if="loading" size="sm" />
        <CIcon v-else name="cil-search" />
      </span>
    </div>
    <ul v-if="open && query.length >= 2" class="address-search-results list-unstyled mb-0" role="listbox" aria-label="Adress-Suchergebnisse">
      <li v-if="!loading && results.length === 0" class="empty-result">Keine Adresse gefunden.</li>
      <li v-for="(item, index) in results" :key="item.id" role="option" :aria-selected="index === selectedIndex">
        <button type="button" :class="['search-result', { active: index === selectedIndex }]" @mousedown.prevent="openAddress(item)">
          <strong>{{ addressLabel(item) }}</strong>
          <span>{{ item.plz }} {{ item.city }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AddressSearch',
  data () {
    return {
      closeTimer: null,
      loading: false,
      open: false,
      query: '',
      requestId: 0,
      results: [],
      searchTimer: null,
      selectedIndex: -1
    }
  },
  beforeUnmount () {
    window.clearTimeout(this.closeTimer)
    window.clearTimeout(this.searchTimer)
  },
  methods: {
    addressLabel (address) {
      return `${address.street || ''} ${address.streetnumber || ''}${address.suffix || ''}`.trim()
    },
    closeAfterFocusChange () {
      window.clearTimeout(this.closeTimer)
      this.closeTimer = window.setTimeout(() => {
        this.open = false
        this.selectedIndex = -1
      }, 150)
    },
    moveSelection (offset) {
      if (this.results.length === 0) {
        return
      }

      this.open = true
      this.selectedIndex = (this.selectedIndex + offset + this.results.length) % this.results.length
    },
    openAddress (address) {
      this.$router.push({ path: `/adressen/editieren/${address.id}` })
      this.reset()
    },
    openSelected () {
      if (this.selectedIndex >= 0 && this.results[this.selectedIndex]) {
        this.openAddress(this.results[this.selectedIndex])
      }
    },
    queueSearch () {
      window.clearTimeout(this.searchTimer)
      const query = this.query.trim()
      if (query.length < 2) {
        this.results = []
        this.selectedIndex = -1
        return
      }

      this.searchTimer = window.setTimeout(() => this.search(query), 250)
    },
    reset () {
      this.open = false
      this.query = ''
      this.results = []
      this.selectedIndex = -1
    },
    async search (query) {
      const requestId = ++this.requestId
      this.loading = true
      this.open = true
      try {
        const response = await this.axios.get('/address/search', {
          params: { query, limit: 8 }
        })
        if (requestId !== this.requestId) {
          return
        }
        this.results = response.data.items
        this.selectedIndex = -1
      } catch (error) {
        if (requestId === this.requestId) {
          this.results = []
        }
      } finally {
        if (requestId === this.requestId) {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.address-search {
  min-width: 17rem;
  position: relative;
}

.address-search-results {
  background: var(--cui-body-bg);
  border: 1px solid var(--cui-border-color);
  border-radius: 0.25rem;
  box-shadow: 0 0.25rem 0.75rem rgba(44, 56, 74, 0.16);
  left: 0;
  max-height: 22rem;
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: calc(100% + 0.25rem);
  z-index: 1050;
}

.search-result {
  background: transparent;
  border: 0;
  display: grid;
  gap: 0.125rem;
  padding: 0.625rem 0.75rem;
  text-align: left;
  width: 100%;
}

.search-result:hover,
.search-result.active {
  background: var(--cui-tertiary-bg);
}

.search-result span,
.empty-result {
  color: var(--cui-secondary-color);
  font-size: 0.75rem;
}

.empty-result {
  padding: 0.75rem;
}
</style>
